"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _Discussion = babelHelpers.interopRequireDefault(require("components/Discussion"));

var _decorators = require("decorators");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _PromiseRenderer = babelHelpers.interopRequireDefault(require("../PromiseRenderer"));

var _ActivityFeed = babelHelpers.interopRequireDefault(require("components/ActivityFeed"));

var _SubmissionInfoBar = require("components/SubmissionInfoBar");

var _SurveyModal = require("components/SurveyModal");

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _temp;

var SubmissionInfoBar = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(SubmissionInfoBar, _Component);

  function SubmissionInfoBar() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, SubmissionInfoBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(SubmissionInfoBar)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "discussionRoot", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "submissionId", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "feedback", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "catalogItem", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "showText", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      discussion: null,
      discussionRoot: null
    };
    return _this;
  }

  babelHelpers.createClass(SubmissionInfoBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var discussion = _Discussion.default.getDiscussion(this.discussionRoot);

      this.setState({
        discussion: discussion
      });
      discussion.then(function (discussion) {
        var discussionRoot = discussion.getDiscussionRoot();

        _this2.setState({
          discussionRoot: discussionRoot
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.feedback || !this.feedback.feed.length) {
        return _react.default.createElement("div", {
          className: "submission-info-bar without-feedback block stack"
        }, _react.default.createElement("div", {
          className: "inner-content"
        }, _react.default.createElement("div", {
          className: "container"
        }, _react.default.createElement(_PromiseRenderer.default, {
          promise: this.state.discussionRoot,
          success: this._renderFeedbackButton
        })), !!this.showText && _react.default.createElement("div", {
          className: "container"
        })));
      }

      return _react.default.createElement("div", {
        className: "submission-info-bar block stack"
      }, _react.default.createElement("div", {
        className: "inner-content"
      }, _react.default.createElement("div", {
        className: "container"
      }, _react.default.createElement("h1", null, "Recent Feedback"), _react.default.createElement(_PromiseRenderer.default, {
        promise: this.state.discussionRoot,
        success: this._renderFeedbackButton
      })), !!this.showText && _react.default.createElement("div", {
        className: "container"
      })), _react.default.createElement("div", {
        className: "activity-feed-element"
      }, _react.default.createElement(_ActivityFeed.default, {
        feedback: this.feedback,
        feedbackOnly: true,
        controls: true,
        handleLink: this.handleNotification
      })));
    }
  }, {
    key: "showSurveyResult",
    value: function showSurveyResult(node) {
      new _SurveyModal.SurveyResultModal(node.survey, node.account, new Date(node.created), node).show();
    }
  }, {
    key: "handleNotification",
    value: function handleNotification(notification, shiftKey) {
      var _this3 = this;

      this.state.discussionRoot.then(function (root) {
        var item = root.children.filter(function (v) {
          return v.node.id == notification.id;
        });

        if (item.length) {
          _this3.showSurveyResult(item[0].node);
        }
      });
    }
  }, {
    key: "_renderFeedbackButton",
    value: function _renderFeedbackButton(result) {
      if (result.node.survey) {
        if (this.showText) {
          return _react.default.createElement("a", {
            onClick: this._doSurvey,
            href: "javascript:void(0)",
            className: "feedback-as-link"
          }, this.showText || result.node.survey.callToAction || 'Leave your feedback');
        }

        return _react.default.createElement("a", {
          className: "btn btn-primary",
          onClick: this._doSurvey,
          href: "javascript:void(0)"
        }, result.node.survey.callToAction || 'Leave your feedback');
      }

      return null;
    }
  }, {
    key: "_doSurvey",
    value: function _doSurvey() {
      var _this4 = this;

      _promisePolyfill.default.all([this.state.discussion, this.state.discussionRoot]).then(function (_ref) {
        var _ref2 = babelHelpers.slicedToArray(_ref, 2),
            discussion = _ref2[0],
            discussionRoot = _ref2[1];

        var callToAction = discussionRoot.node.survey.callToAction;
        var catalogItem = _this4.catalogItem;

        var tree = _react.default.createElement(_SubmissionInfoBar.SurveyHeader, {
          callToAction: callToAction,
          catalogItem: catalogItem
        });

        discussion.leaveSurveyResponse(tree);
      });
    }
  }]);
  return SubmissionInfoBar;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "discussionRoot", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "submissionId", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "feedback", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "catalogItem", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "showText", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "showSurveyResult", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "showSurveyResult"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "handleNotification", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "handleNotification"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_renderFeedbackButton", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_renderFeedbackButton"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_doSurvey", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_doSurvey"), _class.prototype)), _class);
exports.default = SubmissionInfoBar;